module.exports = "https://d1tntvpcrzvon2.cloudfront.net/vpassets/_next/static/images/desktop@2x-27a7d61fa5aafc1a2fff8c2ab9b792b9.jpg";